import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

const getAuthParams = () => {
  try {
    const params = new URLSearchParams(window.location.hash.split('?')[1]);
    return {
      token: params.get('access_token') || params.get('token'),
      noAuth: params.get('no-auth') === 'true',
    };
  } catch {
    return { token: null, noAuth: false };
  }
};


if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)